/**
 * Dashboard widget surfacing recurring meeting series with their open
 * action-item counts. Visible on the home page so corporate buyers see
 * "Standup — 12 meetings, last Wed, 4 open action items" at a glance.
 *
 * The smart wrapper here fetches series-summary data and gates the render
 * (returns null while loading + when no series has 3+ meetings).
 * RecurringSeriesCardView holds the actual layout.
 */

import { useCompanyApi } from "../../hooks/useCompanyApi"
import { useCompanyQuery } from "../../hooks/useCompanyQuery"
import { fetchSeriesSummary } from "../../lib/api"
import { queryKeys } from "../../lib/query-keys"
import { RecurringSeriesCardView } from "./RecurringSeriesCardView"
import type { ISeriesSummary } from "./RecurringSeriesCardView/interfaces"

export function RecurringSeriesCard(): React.JSX.Element | null {
  const company = useCompanyApi()

  const { data, isLoading } = useCompanyQuery({
    key: queryKeys.seriesSummary,
    queryFn: (client) => fetchSeriesSummary(client),
    staleTime: 60_000,
  })

  if (!company) return null
  if (isLoading) return null

  const series = (data ?? []) as ISeriesSummary[]
  return <RecurringSeriesCardView series={series} />
}
